import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WrapInputModel } from '../../interfaces/wrapper.model';




@Component({
  selector: 'app-base',
  template: ``,
  styleUrls: [],
})
export class BaseComponent {
  @Input() parameters: WrapInputModel<any> | any;
  @Output() action = new EventEmitter<any>();
}
